var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cs-button',{attrs:{"icon-type":"material","type":"primary"},on:{"click":_vm.download}},[_vm._v(" "+_vm._s(_vm.$t('components.XlsxImporter.sample'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }